import {UserIcon} from '@/components/svg/UserIcon';
import {ChevronDownIcon} from '@chakra-ui/icons';
import {Box, Button, MenuButton, Text} from '@chakra-ui/react';

export const ButtonUser: React.FC<{nom: string}> = ({nom}) => {
  return (
    <MenuButton
      as={Button}
      rightIcon={<ChevronDownIcon />}
      variant='unstyle'
      backgroundColor='transparent'
      color='white'
      _hover={{bg: 'transparent'}}
      fontWeight='500'
      aria-label={nom}
    >
      <Box
        display='flex'
        alignItems='center'
      >
        <Box marginRight={{base: '0', md: '5px'}}>
          <UserIcon />
        </Box>
        {/* Raison sociale tronquée : certains noms sont très longs et pousseraient le
            reste du bandeau hors de l'écran. */}
        <Text
          fontSize='sm'
          display={{base: 'none', md: 'block'}}
          isTruncated
          maxW={{md: '100px', lg: '200px', xl: '300px'}}
        >
          {nom}
        </Text>
      </Box>
    </MenuButton>
  );
};
